import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { injectXingHub } from '@xingternal/xing-hub';

import { t } from '@xingternal/content-helpers';
import { trackingEnvironment } from '@xingternal/content-tracking';

import { ErrorGraphql } from '../ErrorGraphql';

import ErrorContext from './ErrorContext';
import ErrorMessage from './ErrorMessage';

export const ERROR_MESSAGE_DURATION_PROD = 3000;
export const ERROR_MESSAGE_DURATION_DEV = 20000;

class ErrorContainer extends React.Component {
  constructor(props) {
    super(props);

    this.showError = ({ message, error }) => {
      const isUserOffline = error?.networkError?.isUserOffline;

      this.setState(() => ({
        show: isUserOffline || Boolean(message),
        message: t(
          this.props.intl,
          isUserOffline ? 'CONTENT_ERROR_OFFLINE' : message
        ),
        error,
        closeTimer: setTimeout(
          () => this.hideError(),
          trackingEnvironment !== 'production'
            ? ERROR_MESSAGE_DURATION_DEV
            : ERROR_MESSAGE_DURATION_PROD
        ),
      }));
    };

    this.hideError = () => {
      this.setState((state) => ({
        show: false,
        message: '',
        error: null,
        closeTimer: state.closeTimer ? clearTimeout(state.closeTimer) : null,
      }));
    };

    this.state = {
      show: false,
      message: '',
      error: null,
      showError: this.showError,
      closeTimer: null,
    };
  }

  componentDidCatch(error, errorInfo) {
    const { captureException } = this.props;

    // eslint-disable-next-line no-console
    (captureException || console.error)(error, errorInfo);
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    return (
      <ErrorContext.Provider value={this.state}>
        {error && trackingEnvironment !== 'production' && (
          <ErrorGraphql error={error} title={'Error debug message'} />
        )}
        <ErrorMessage onClick={this.hideError} />
        {children}
      </ErrorContext.Provider>
    );
  }
}

ErrorContainer.propTypes = {
  intl: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  captureException: PropTypes.func,
};

export default injectXingHub(injectIntl(ErrorContainer));
